import React from "react";

import { TaskV4Dto } from "@fartherfinance/frontend/api/TaskWorkflows/hooks/useGetTasks";
import { TaskBasicInfo } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

import TaskProgressChip from "./TaskProgressChip";
import TaskSubtaskTooltip from "./TaskSubtaskTooltip";

import styles from "./TaskProgressIndicator.module.css";

interface TaskProgressIndicatorProps {
  task: TaskV4Dto;
  subtasks: TaskBasicInfo[];
}

const TaskProgressIndicator: React.FC<TaskProgressIndicatorProps> = ({
  task,
  subtasks,
}) => {
  return (
    <TaskSubtaskTooltip subtasks={subtasks} task={task}>
      <TaskProgressChip
        className={styles.progressChip}
        variant="counter-only"
        subtasks={subtasks}
      />
    </TaskSubtaskTooltip>
  );
};

export default TaskProgressIndicator;
